'use client';

import React from 'react';
import {Box, Link} from '@mui/material';
import {TagCloud} from 'react-tagcloud'
import Tag from "@/src/_types/tag";
import NextLink from "next/link";

interface CustomTagCloudProps {
    data: Tag[];
}

const CustomTagCloud: React.FC<CustomTagCloudProps> = (props) => {
    const renderTag = (tag: Tag, size: number, color: string) => {
        const query = encodeURIComponent(tag.value);
        return (
            <Box
                component={"span"}
                className={'tag-cloud-tag'}
                sx={{
                    margin: '0px 3px',
                    verticalAlign: 'middle',
                    display: 'inline-block',
                }}
                key={tag.value}
            >
                <Link
                    component={NextLink}
                    href={`https://repository.brieflands.com/search?query=${query}`}
                    target="_blank"
                    style={{
                        fontSize: `${size}px`,
                        color,
                        margin: '3px',
                        textDecoration: 'none',
                    }}
                >
                    {tag.value}
                </Link>
            </Box>
        );
    };

    return (
        <TagCloud
            minSize={9}
            maxSize={35}
            tags={props.data || []}
            renderer={renderTag}
        />
    );
};

export default CustomTagCloud;
